module.exports = __webpack_public_path__ + "static/media/EditBack.fb2a109e.jpg";